<p-dialog *ngIf="appointment"
          header="{{ (appointment.id ? 'ADD_APPOINTMENT_DIALOG.MODIFY_HEADER' : 'ADD_APPOINTMENT_DIALOG.NEW_HEADER') | translate }}"
          [(visible)]="display"

          [modal]="true"
          [draggable]="false">
  <form [formGroup]="appointmentForm" (submit)="save()">
    <div class="ui-g service-edit-dialog">
      <div class="ui-g-12">
        <div class="ui-g m-b-0">
          <div class="ui-g-5">
            <label>{{'WS_DIRECTORY.PERSON_MODIFY.ORGANIZATION' | translate}}</label>
          </div>
          <div class="ui-g-7">
            <wsd-select-organization-ac [showLabel]="false"
                                        [parentForm]="appointmentForm">
            </wsd-select-organization-ac>
          </div>
          <div class="ui-g-5">
            <label>{{ 'SELECT_STANDARD_TITLE.LABEL' | translate }}</label>
          </div>
          <div class="ui-g-7">
            <wsd-select-standard-title [showLabel]="false"
                                       (onSelect)="onStandardTitleChange($event)"
                                       [parentForm]="appointmentForm">
            </wsd-select-standard-title>
          </div>
          <div class="ui-g-5">
            <label>{{ 'WS_DIRECTORY.PERSON_MODIFY.DIRECTORY_TITLE' | translate }}</label>
          </div>
          <div class="ui-g-7">
            <gs-extended-input [control]="appointmentForm.get('directoryTitle')">
              <input pInputText formControlName="directoryTitle">
            </gs-extended-input>
          </div>
          <div class="ui-g-5">
            <label>{{ 'WS_DIRECTORY.PERSON_MODIFY.SECOND_DIRECTORY_TITLE' | translate }}</label>
          </div>
          <div class="ui-g-7">
            <gs-extended-input [control]="appointmentForm.get('directorySecondTitle')">
              <input pInputText formControlName="directorySecondTitle">
            </gs-extended-input>
          </div>
          <div class="ui-g-5">
            <label>{{ 'WS_DIRECTORY.PERSON_MODIFY.IS_OFFICIAL' | translate }}</label>
          </div>
          <div class="ui-g-7">
            <p-checkbox formControlName="official" binary="true" class="m-t-10"></p-checkbox>
          </div>
          <div class="ui-g-5">
            <label>{{ 'WS_DIRECTORY.PERSON_MODIFY.APPOINTMENT_EMAIL' | translate }}</label>
          </div>
          <div class="ui-g-7">
            <gs-extended-input [control]="appointmentForm.get('email')">
              <p-dropdown [options]="emailItems" formControlName="email"></p-dropdown>
            </gs-extended-input>
          </div>
          <div class="ui-g-5"></div>
          <div class="ui-g-7">
            <button pButton label="{{ (appointment.id ? 'ADD_CONTACT_DIALOG.UPDATE_BTN' : 'ADD_CONTACT_DIALOG.ADD_BTN') | translate }}"
                    class="ui-button-success">
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</p-dialog>
